module.exports = __webpack_public_path__ + "static/media/pw.8207f624.svg";